import { setupWhatsAppModal } from '../modals/WhatsAppModal.js';

const getWhatsAppStatusClass = (status) => {
    switch (status) {
        case 'connected':
            return 'text-green-600 font-semibold';
        case 'pending':
            return 'text-yellow-600 font-semibold';
        case 'disconnected':
        case 'unpaired':
            return 'text-red-600 font-semibold';
        default:
            return 'text-gray-600';
    }
};

const getWhatsAppStatusText = (status) => {
    switch (status) {
        case 'connected':
            return 'Подключено';
        case 'pending':
            return 'В ожидании';
        case 'disconnected':
            return 'Не привязан';
        default:
            return 'Не подключено';
    }
};

export const renderCompanyCard = (company) => {
    if (company.loading) {
        return `
            <div class="bg-white rounded-lg shadow-md p-6 relative">
                <div class="absolute inset-0 bg-white bg-opacity-75 flex items-center justify-center">
                    <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                </div>
                <div class="animate-pulse">
                    <div class="h-4 bg-gray-200 rounded w-3/4 mb-4"></div>
                    <div class="h-3 bg-gray-200 rounded w-1/2 mb-2"></div>
                    <div class="h-3 bg-gray-200 rounded w-2/3 mb-2"></div>
                    <div class="h-3 bg-gray-200 rounded w-1/2 mb-4"></div>
                    <div class="space-y-2">
                        <div class="h-8 bg-gray-200 rounded"></div>
                        <div class="h-8 bg-gray-200 rounded"></div>
                        <div class="h-8 bg-gray-200 rounded"></div>
                    </div>
                </div>
            </div>
        `;
    }
    
    return `
        <div class="bg-white rounded-lg shadow-md p-6" data-company-id="${company.id}">
            <div class="flex justify-between items-start mb-4">
                <h3 class="text-xl font-semibold text-gray-900">${company.name}</h3>
                <div class="flex space-x-2">
                    <button class="edit-company-btn p-2 text-blue-600 hover:text-blue-800">
                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                                  d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
                        </svg>
                    </button>
                    <button class="delete-company-btn p-2 text-red-600 hover:text-red-800">
                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                        </svg>
                    </button>
                </div>
            </div>

            <div class="mb-4">
                <p class="text-gray-600">Kaspi ID: ${company.kaspi_uid}</p>
                <div class="flex items-center space-x-2">
                    <p class="text-gray-600">WhatsApp: ${company.whatsapp_phone}</p>
                    ${company.whatsapp_status ? `
                        <span class="inline-flex items-center px-2 py-0.5 rounded text-sm ${getWhatsAppStatusClass(company.whatsapp_status)}">
                            ${getWhatsAppStatusText(company.whatsapp_status)}
                        </span>
                    ` : ''}
                </div>
                <p class="text-gray-600">Шаблоны: ${company.templates.length}</p>
                <!--<p class="text-gray-600">Статус оплаты: ${company.payment ? company.payment.status : 'Оплата отсутствует'}</p>-->
                <p class="text-gray-600">Рассылка: ${company.mailing_enabled ?
                    `<span class="text-green-600 font-semibold">Активна</span> (${company.mailing_start_time} - ${company.mailing_end_time})` :
                    'Отключена'}</p>
                ${company.whatsapp_status === 'connected' ? `
                <div class="flex items-center">
                    <p class="text-gray-600">Тестовый режим:</p>
                    <span class="ml-2 inline-flex items-center">
                        ${company.test_mode ?
                            `<span class="text-yellow-600 font-semibold flex items-center">
                                <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                                </svg>
                                Активен
                            </span>` :
                            `<span class="text-gray-600">Отключен</span>`
                        }
                        <div class="ml-1 group relative">
                            <svg class="w-4 h-4 text-gray-400 cursor-help" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                            </svg>
                            <div class="hidden group-hover:block absolute z-10 w-64 p-2 bg-gray-800 text-white text-xs rounded shadow-lg -top-2 left-6">
                                Когда тестовый режим активен, все сообщения WhatsApp будут отправляться на ваш номер WhatsApp вместо клиентов.
                            </div>
                        </div>
                    </span>
                </div>
                ` : ''}
            </div>

            <div class="space-y-2">
                <button class="manage-templates-btn w-full py-2 px-4 bg-yellow-600 text-white rounded hover:bg-yellow-700">
                    Управление шаблонами
                </button>
                <!--<button class="manage-payment-btn w-full py-2 px-4 bg-purple-600 text-white rounded hover:bg-purple-700">
                    Управление оплатой
                </button>-->
                <button class="view-statistics-btn w-full py-2 px-4 bg-blue-600 text-white rounded hover:bg-blue-700">
                    Просмотр статистики
                </button>
                <button class="manage-whatsapp-btn w-full py-2 px-4 bg-green-600 text-white rounded hover:bg-green-700">
                    Управление WhatsApp
                </button>
            </div>
        </div>
    `;
};
